import explore_image from '@/public/features/explore.webp';
import schedule_5 from '@/public/features/sales/Access-to-Consumer-Financing-Options.webp';
import schedule_4 from '@/public/features/sales/Accurate-Estimate-Generation.webp';
import schedule_2 from '@/public/features/sales/Empower-Your-Team-to-Perform-Better-On-Site.webp';
import bg from '@/public/features/sales/Frame-1171279302.webp';
import schedule_1 from '@/public/features/sales/Good_-Better_-Best-Options.webp';
import app_2 from '@/public/features/sales/Project-history.webp';
import schedule_3 from '@/public/features/sales/Streamline-Payment-Processes-with-Ease.webp';
import app_1 from '@/public/features/sales/What-is-invoicing-software.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Sales Proposal Software',
  description: `Discover the ultimate tool for closing deals faster with our sales proposal software. Craft personalized, professional proposals that stand out from the competition with ease. Our intuitive design, combined with powerful customization features, ensures that you can focus on what matters most – winning clients.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Effortlessly Create Winning',
  second_title: 'Sales Proposals in Minutes!',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: 'How to Choose the Best Sales Proposal Software for My Needs?',
      text: `Selecting the right software hinges on identifying your needs. Consider features like template variety, customization, and integration with your current tools. Don’t forget to check customer reviews and opt for software that balances functionality with ease of use.`,
    },
    {
      title: `Why Would I Need Sales Proposal Software for My Small Business?`,
      text: `Even small businesses can reap big rewards from sales proposal software. It streamlines your process, saves time, and improves proposal quality. This investment can lead to higher conversion rates and enhanced client relationships.`,
    },
    {
      title: `Can Sales Proposal Software Integrate with Field Service Management Tools?`,
      text: `Absolutely! Many sales proposal platforms offer seamless integration with field service software, ensuring that your sales and service teams are in sync. This leads to more cohesive customer interactions and streamlined operations.`,
    },
    {
      title: `How Can Sales Proposal Software Improve My Team’s Efficiency?`,
      text: `Sales proposal software automates many of the repetitive tasks involved in proposal creation. This means your team spends less time on paperwork and more time on selling. It’s a simple way to boost productivity and close more deals faster.`,
    },
    {
      title: `What Advantages Does Sales Proposal Software Offer Over Traditional Methods?`,
      text: `Sales proposal software eclipses traditional methods by offering real-time collaboration, tracking, and management tools. It produces proposals with greater speed and consistent quality. It eliminates manual errors and provides valuable insights into client interactions, which can enhance decision-making and, ultimately, your closure rate.`,
    },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `We used to spend a lot of time creating professional-looking sales proposals. With Orcatec, this process has become much easier and faster. The library of ready-to-use, branded templates saves us a lot of effort.`,
      name: 'Jason A.',
      position: 'Owner of an appliance repair company',
    },
    {
      text: `Orcatec's interactive sales proposals have made a splash with our customers. Being able to configure the service packages ourselves is impressive. We've started selling significantly more add-on options.`,
      name: 'Carla R., Sales Manager,',
      position: 'House Cleaning Company',
    },
    {
      text: `The seamless integration with the dispatch module and billing is something we have been looking for for a long time. The time savings are tremendous. And the ability to track order status at all stages greatly simplifies workflow management.`,
      name: 'Howard T., COO,',
      position: 'Garage Door Repair Company',
    },

    {
      text: `We used to spend a lot of time creating professional-looking sales proposals. With Orcatec, this process has become much easier and faster. The library of ready-to-use, branded templates saves us a lot of effort.`,
      name: 'Jason A.',
      position: 'Owner of an appliance repair company',
    },
    {
      text: `Orcatec's interactive sales proposals have made a splash with our customers. Being able to configure the service packages ourselves is impressive. We've started selling significantly more add-on options.`,
      name: 'Carla R., Sales Manager,',
      position: 'House Cleaning Company',
    },
    {
      text: `The seamless integration with the dispatch module and billing is something we have been looking for for a long time. The time savings are tremendous. And the ability to track order status at all stages greatly simplifies workflow management.`,
      name: 'Howard T., COO,',
      position: 'Garage Door Repair Company',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `We explore the latest trends in sales proposal strategies and offer expert advice to empower your team's success. Dive into our articles for actionable tips and industry secrets that will revolutionize the way you approach your sales process.`,
};

const bookDemo = {
  title: `Ready to transform your proposals\xa0into\xa0deal-closers?`,
  description: `We're here to help. Fill out the contact form below for a tailored consultation and discover the difference the right tools can make. Your journey to sales excellence is just one click away.`,
};

const articles = {
  title: `How Does Sales Proposal\xa0Software\xa0Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Good, Better, Best Options',
      text: `Sales proposal software provides a tiered approach to proposal creation, known as 'Good, Better, Best.' This feature allows sales teams to offer a range of options tailored to different customer needs and budgets. \n\nBy presenting multiple packaged choices, clients can compare offerings and select the one that best aligns with their requirements and financial capacity, thus facilitating a more personalized sales experience and potentially increasing the deal size.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Pre-built Proposal Templates',
      text: `For efficiency and convenience, the software includes a variety of pre-built proposal templates. These templates serve as a starting point for creating detailed, professional proposals without having to build them from scratch each time.\n\nWhether it's a standard service offer or a complex project bid, these templates make the process quick and easy, saving valuable time.`,
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `Customizable and Personalized\xa0Proposals`,
      text: `At the core of the software's functionality is its ability to produce highly customizable and personalized proposals. You can tailor every aspect of the proposal, from headers and layouts to itemized or total pricing, ensuring that each proposal reflects the unique value proposition you offer to the client.\n\nThis level of personalization helps to create a connection with the client and demonstrates a deep understanding of their needs.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_5,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Consumer Financing',
      text: `A standout feature of advanced sales proposal quote software is the integration of consumer financing options. This allows your clients the flexibility to pay over time for your products or services.\n\nProviding this option can make your offerings more accessible to a broader audience and can be a deciding factor for clients who are considering a significant investment.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Optional and Add-On Items',
      text: `To enhance the customization capabilities, the software sales proposal enables the inclusion of optional and add-on items within your proposals. This not only gives clients the liberty to tailor the proposal to their exact needs but also serves as an effective upselling free sales proposal tool.\n\nBy clearly displaying additional goods or services, clients can easily opt-in for more features or higher service levels, increasing the overall value of the sale.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is\xa0Right\xa0For\xa0You?`,
  description: `Our proposal software solutions for sales teams equip you with the tools you need to produce impactful, persuasive proposals that resonate with your clients. Experience the power of efficiency and customization at your fingertips, and see how our solution can become the growth catalyst for your business.`,
  item: [
    {
      title: 'Cost-Effective Start',
      description:
        'Dive into the world of efficient proposal management with our complimentary starter plan. Get accustomed to the basics without any upfront investment, ensuring a seamless and cost-effective entry into improved sales processes.',
    },
    {
      title: 'Tailored to Your Needs',
      description: `Our software boasts a spectrum of customizable options. Whether you're a startup or a large enterprise, choose and pay for only the features you need. Our modular design means that as your business evolves, so does your proposal software—ensuring a perfect fit at every stage of growth.`,
    },
    {
      title: 'Support That’s Always There.',
      description: `Immediate, round-the-clock support is fundamental to our service promise. Whenever you need assistance, our responsive team is ready to help. We ensure your operations run smoothly, minimizing downtime and maximizing your ability to create and deliver winning proposals.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Sales Proposal Software?`,
  },
  title: `What Is Sales Proposal Software?`,
  description: `Sales proposal software is an essential tool for crafting compelling sales proposals that capture client attention and seal the deal. With our advanced platform, creating customized, persuasive, and professionally designed proposals has never been easier. Our software is engineered to enhance your sales process, providing a comprehensive proposal generation tool that simplifies creating, managing, and sending sales proposals. It consolidates your sales materials into one accessible location, offering a robust set of features for businesses of all sizes. The key benefits are:`,
  item: [
    {
      title: 'Streamlined Proposal Creation',
      description:
        'Dramatically cut down the time it takes to generate proposals with customizable templates and a rich content library, ensuring consistency and brand alignment across all documents.',
    },
    {
      title: 'Enhanced Collaboration',
      description:
        'Collaborate in real-time with team members, track changes, and manage versions to improve proposal quality and accuracy, leading to increased approval rates.',
    },

    {
      title: 'In-depth Analytics and Reporting',
      description: `Gain insights into how your proposals perform with analytics that track client engagement, helping you refine and optimize for future success.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
